// export { default } from './api'
export * from './api'
//这里面对应着四个方法 get put post del四个方法

import { http,get,post,put,del} from './api'


const apiServe = {
    // 确定好什么方法之后，直接传递参数过来就行，在这边写get post put del
    getNewsData: (data, method) => post('/api/index/news', data),
    postProductData: (data, method) => post('/api/index/product', data),
    postNewsDetailData: (data, method) => post('/api/index/newsD', data),
    getIndexData: (data, method) => get('/api/index/index', data),
    getAboutData: (data, method) => get('/api/index/about', data),
    getCoreData: (data, method) => get('/api/index/core', data),
    getMoreData: (data, method) => get('/api/index/contact', data),
    postCasesData: (data, method) => post('/api/index/cases', data),
    postAppDetailData: (data, method) => post('/api/index/coreD', data),
    postMessageData: (data, method) => post('/api/index/message', data),

}

export default apiServe